import axios from 'axios';

const API_URL = process.env.REACT_APP_BASEURL + 'subjectWorkload';
const API_URL2 = process.env.REACT_APP_BASEURL + 'teacherWorkload';

export const addSubjectWorkload = (reqData: Object) => {
  return axios.post(API_URL + '/add', reqData);
};
export const subjectTimeoff = (reqData: Object) => {
  return axios.post(API_URL + '/subject-timeoff', reqData);
};
export const editsubjectWorkload = (reqData: Object) => {
  return axios.put(API_URL + '/', reqData);
};
export const deletesubjectWorkload = (reqData: Object) => {
  return axios.delete(API_URL + '/', { params: reqData });
};

export const getSubjectWorkload = (reqData: Object) => {
  return axios.get(API_URL + '/all', { params: reqData });
};
export const addTeacherWorkload = (reqData: Object) => {
  return axios.post(API_URL2 + '/add', reqData);
};
export const teacherTimeoff = (reqData: Object) => {
  return axios.post(API_URL2 + '/teacher-timeoff', reqData);
};

export const getTeacherWorkload = (reqData: Object) => {
  return axios.get(API_URL2 + '/all', { params: reqData });
};

export const editTeacherWorkload = (reqData: Object) => {
  return axios.put(API_URL2 + '/', reqData);
};

export const deleteTeacherWorkload = (reqData: Object) => {
  return axios.delete(API_URL2 + '/', { params: reqData });
};

export const timeoffTeacher = (reqData: Object) => {
  return axios.get(API_URL2 + '/teacher-timeoff', { params: reqData });
};
export const timeoffSubject = (reqData: Object) => {
  return axios.get(API_URL + '/subject-timeoff', { params: reqData });
};
